import APIService from "./APIService";

/**
 * Service for handling forgot password API operations
 */
const ForgotPasswordAPI = {
  /**
   * Request a password reset for the given email
   * @param {string} email - User's email address
   * @returns {Promise} - Promise that resolves with the request result
   */
  requestPasswordReset: async (email) => {
    try {
      const response = await APIService.post("/api/v1/base/forgot-password/request", {
        email,
        timestamp: new Date().toISOString(),
      });

      console.log(
        `[ForgotPasswordAPI] Password reset request response:`,
        response
      );
      return response.data || response;
    } catch (error) {
      console.error(
        "[ForgotPasswordAPI] Error requesting password reset:",
        error
      );
      throw error;
    }
  },

  /**
   * Validate a password reset token
   * @param {string} token - Reset token from email link
   * @returns {Promise} - Promise that resolves with validation result
   */
  validateResetToken: async (token) => {
    try {
      const response = await APIService.get(
        `/api/v1/base/forgot-password/validate/${encodeURIComponent(token)}`
      );

      console.log(`[ForgotPasswordAPI] Token validation response:`, response);
      return response.data || response;
    } catch (error) {
      console.error("[ForgotPasswordAPI] Error validating reset token:", error);
      throw error;
    }
  },

  /**
   * Reset password with token and new password
   * @param {string} token - Reset token from email link
   * @param {string} newPassword - New password
   * @returns {Promise} - Promise that resolves with reset result
   */
  resetPassword: async (token, newPassword) => {
    try {
      const response = await APIService.post("/api/v1/base/forgot-password/reset", {
        token,
        newPassword,
        timestamp: new Date().toISOString(),
      });

      console.log(`[ForgotPasswordAPI] Password reset response:`, response);
      return response.data || response;
    } catch (error) {
      console.error("[ForgotPasswordAPI] Error resetting password:", error);
      throw error;
    }
  },
};

export default ForgotPasswordAPI;
